'use client';

import { CircleHalfIcon } from '@phosphor-icons/react';
import { PickerDrawer } from './PickerDrawer';
import type { TransactionDirection } from '@/lib/transactions/types';
import { DIRECTION_OPTIONS } from './transactionType';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: TransactionDirection | null;
  onSelect: (value: TransactionDirection | null) => void;
}

/**
 * "Tipo" filter (VER-259): Todas / Entradas / Saídas — single-select, since a transaction is
 * either income or an expense. Uses the shared PickerDrawer so it behaves exactly like the other
 * filter chips (Forma de pagamento, Conta): tap the chip → drawer → pick → auto-close.
 * Entradas maps to bank income and Saídas to expenses at the query layer (see TransactionsScreen).
 * Note: the recurrence groups live in their own "Recorrência" chip — this one is direction only.
 */
export function DirectionPickerDrawer({ open, onOpenChange, value, onSelect }: Props) {
  return (
    <PickerDrawer<TransactionDirection | null>
      open={open}
      onOpenChange={onOpenChange}
      title="Tipo"
      options={[
        { value: null, label: 'Todas', Icon: CircleHalfIcon },
        ...DIRECTION_OPTIONS,
      ]}
      value={value}
      onSelect={onSelect}
      onClear={value ? () => onSelect(null) : undefined}
    />
  );
}
